'use client';

import { useTranslations } from 'next-intl';
import React, { FC, SyntheticEvent } from 'react';

import ArrowIcon from '@/public/icons/right_arrow_circle.svg';

interface SeeAllButtonProps {
  onClick: (() => void) | ((event: SyntheticEvent) => void);
  categoryId?: string;
  styleId?: string;
}

const styles = {
  seeAll:
    'text-sm flex items-center gap-1 rounded-full py-1 pl-2 pr-1 border-1 border-gray',
  arrow: 'w-5 h-5',
};

export const SeeAllButton: FC<SeeAllButtonProps> = ({
  onClick,
  categoryId,
  styleId,
}) => {
  const t = useTranslations('MenuPage');
  return (
    <button
      className={styles.seeAll}
      data-category-id={categoryId}
      data-style-id={styleId}
      onClick={onClick}
    >
      {t('seeAll')}
      <ArrowIcon className={styles.arrow} />
    </button>
  );
};
